import { useCallback } from 'react'
import { useIntl } from '@/i18n/hooks/use-intl'
import { OurIntlShape } from '@/i18n/typing'

type UseFormatNumberRange = () => (
  startRange: number,
  endRange: number,
  opts?: Parameters<OurIntlShape['formatNumber']>[1] & { separator?: string },
) => string

const useFormatNumberRange: UseFormatNumberRange = () => {
  const { formatNumber } = useIntl()

  return useCallback(
    (startRange, endRange, opts) => {
      return [
        formatNumber(startRange, opts),
        formatNumber(endRange, opts),
      ].join(opts?.separator ?? '~')
    },
    [formatNumber],
  )
}

export default useFormatNumberRange
